/**
 * Shared difficulty enum — used by Route and Plan.
 */

import { Type, type Static } from 'typebox'

export const DifficultySchema = Type.Union([
  Type.Literal('beginner'),
  Type.Literal('intermediate'),
  Type.Literal('advanced'),
  Type.Literal('expert'),
])
export type Difficulty = Static<typeof DifficultySchema>
